import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

import useRoutePaths from '@/src/hooks/useRoutePaths';

import {PreviewImageVideo, Text} from '../../ui';
import css from '../styles/ContentCreatorCourses.module.css';

const ContentCreatorCourses = ({courses}) => {
  const {COURSES_ROUTE} = useRoutePaths();

  return (
    <div className={css.coursesWrapper}>
      {courses.map((course) => {
        return (
          <Link href={COURSES_ROUTE.getLink(course.slug)} key={course.id}>
            <a>
              <div className={css.videoWrapper}>
                <div>
                  <PreviewImageVideo image={course.previewImage} />
                </div>
                <div>
                  <Text
                    fontSize={Text.FONT_SIZE.SIZE_16}
                    fontWeight={Text.FONT_WEIGHT.BOLD}
                    lineHeight={Text.LINE_HEIGHT.LINE_HEIGHT_1_6}
                  >
                    {course.title}
                  </Text>
                </div>
              </div>
            </a>
          </Link>
        );
      })}
    </div>
  );
};

ContentCreatorCourses.propTypes = {
  courses: PropTypes.array,
};

export default ContentCreatorCourses;
